// Offline fallback when the Langfuse prompt config does not specify a model.
export const DEFAULT_OPENAI_MODEL = 'gpt-4o';
